import { App } from '@vue/runtime-core';

import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import Breakpoints from '@/core/responsive/breakpoints/Breakpoints.vue';
import ResponsiveImage from '@/core/responsive/image/ResponsiveImage.vue';
import LazyInit from '@/core/rendering/LazyInit.vue';

export default function coreComponentRegistration(app: App<Element>) {
    app.component(RouterLinkConditional.name, RouterLinkConditional);
    app.component(Breakpoints.name, Breakpoints);
    app.component(ResponsiveImage.name, ResponsiveImage);
    app.component(LazyInit.name, LazyInit);
}
